import type { U2000AutoCompleteSearchResult } from '../types/U2000AutoCompleteSearchResult';

/**
 * Limite le nombre de lignes affichées dans le dropdown (pageSize UI).
 * Conserve totalCount backend ; force truncated si la liste dépasse pageSize.
 */
export function u2000CapAutoCompleteSearchResults<T>(
  normalized: U2000AutoCompleteSearchResult<T>,
  pageSize: number,
): U2000AutoCompleteSearchResult<T> {
  const results = normalized.results ?? [];
  const totalCount = normalized.totalCount ?? results.length;
  if (pageSize <= 0 || results.length <= pageSize) {
    const truncated =
      normalized.truncated === true || (typeof totalCount === 'number' && totalCount > results.length);
    return { results, totalCount, truncated };
  }
  return {
    results: results.slice(0, pageSize),
    totalCount,
    truncated: true,
  };
}
